<template>

    <div class="recent_news">
        <div v-if="fetchslideLists">
            <div v-if="fetchslideLists.length>0">
                <post-image  :posts="fetchslideLists" />
                  <!-- <post-image :posts="fetchMentoryLists" /> -->
            </div>
                <div v-else class="content_empty">
                등록된 글이 없습니다.
            </div>
          
        </div>
          <div class="loading-spinner" v-if="isLoading">
                <base-spinner></base-spinner>
            </div>
    </div>

    <div class="recent_posts">
        <div class="cont">
            <div class="post_block">
                <div class="title">
                    <span>게임등급&질의</span>
                    <span class="more" @click="moreview('Gamegrade','','')">+</span>
                </div>
                <div v-if="fetchGamegradeLists">
                    <div v-if="fetchFreeLists.length>0">
                        <post-content :post="fetchGamegradeLists[0]" imgheight="150px" imgwidth="255px" radius="0" fontWeight="bold" titlelength=20 />
                        <!-- <post-content :post="fetchGamegradeLists[0]" imgheight="120px" imgwidth="150px" mode="blog_left"/> -->
                        <div class="title_list_wrap">
                            <template v-for="(recent, index) in fetchGamegradeLists" :key="index" >
                                <div class="title_list" v-if="index>0"><post-content :post="recent"  titlelength=25  :imgview="false" /></div>
                            </template>
                        </div>                        
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_gamegrade">
                    <base-spinner></base-spinner>
                </div>
            </div>
            <div class="post_block" >
                <div class="title">                
                    <span>멘토리</span>
                    <span class="more" @click="moreview('Mentory','','')"> + </span>
                </div>
                <div v-if="fetchMentoryLists">
                    <div v-if="fetchMentoryLists.length>0">
                        <post-content :post="fetchMentoryLists[0]" :isDocView="true" imgheight="150px" imgwidth="255px" radius="0" fontWeight="bold" titlelength=20 />
                        <!-- <post-blog :post="fetchMentoryLists[0]" :isDocView="true"/> -->
                        <!-- <post-content :post="fetchMentoryLists[0]" imgheight="120px" imgwidth="150px" mode="blog_left"/> -->
                        <div class="title_list_wrap">
                            <template v-for="(recent, index) in fetchMentoryLists" :key="index">
                                <div class="title_list" v-if="index>0"><post-content :post="recent"  titlelength=20 :imgview="false" :isDocView="true"/></div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_mentory">
                    <base-spinner></base-spinner>
                </div>
            </div>
            <div class="post_block" >
                <div class="title">               
                    <span> 뉴스/이슈</span>
                    <span class="more" @click="moreview('Community','News','')"> + </span>
                </div>
                <div v-if="fetchNewsLists">
                    <div v-if="fetchNewsLists.length>0">
                        <post-content :post="fetchNewsLists[0]"  imgheight="150px" imgwidth="255px" radius="0" fontWeight="bold" titlelength=20  />
                        <!-- <post-content :post="fetchNewsLists[0]" imgheight="120px" imgwidth="150px" mode="blog_left"/> -->
                        <div class="title_list_wrap">
                            <template v-for="(recent, index) in fetchNewsLists" :key="index">
                                <div class="title_list" v-if="index>0" ><post-content :post="recent" titlelength=25 :isDocView="false" :imgview="false"/></div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_news">
                    <base-spinner></base-spinner>
                </div>
            </div>
        </div>
        

    </div>


    <div class="recent_posts">
        <div class="title_wrap"><base-title>커뮤니티</base-title></div>
        <div class="cont">
            <div class="post_block" >
                <div class="title">
                    <span> 자유</span>
                    <span class="more" @click="moreview('Community','free','')"> + </span>
                </div>
                <div v-if="fetchFreeLists">
                    <div v-if="fetchFreeLists.length>0" class="cont_wrapper">
                        <post-content :post="fetchFreeLists[0]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                        <div class="list_type">
                            <template v-for="(recent, index) in fetchFreeLists" :key="index">
                                <div class="title_list" v-if="index>0">
                                    <span  class="bullet">-</span>
                                    <post-content :post="recent"  titlelength=20 :isDocView="false" :imgview="false"/>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_free">
                    <base-spinner></base-spinner>
                </div>
            </div>

            <div class="post_block">
                <div class="title">
                    <span> 유머</span>
                    <span class="more" @click="moreview('Community','humor','')"> + </span>
                </div>
                <div v-if="fetchHumorLists">
                    <div v-if="fetchHumorLists.length>0"  class="cont_wrapper">
                        <post-content :post="fetchHumorLists[0]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                        <div class="list_type">
                            <template v-for="(recent, index) in fetchHumorLists" :key="index">
                                <div class="title_list" v-if="index>0">
                                    <span  class="bullet">-</span>
                                    <post-content :post="recent"  titlelength=20 :isDocView="false" :imgview="false"/>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_humor">
                    <base-spinner></base-spinner>
                </div>
            </div>      
            <!-- <div class="post_block">
                <div class="title">
                    <span> 포토</span>
                    <span class="more" @click="morelink('Community','photo')"> + </span>
                </div>
                <div v-if="fetchPhotoLists">
                    <div v-if="fetchPhotoLists.length>0" class="photo_type">                       
                        <template v-for="(recent, index) in fetchPhotoLists" :key="index">
                            <div class="photo_rect" >
                                <post-gallery :post="recent" :titleview="false"/>
                            </div>
                        </template>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_photo">
                    <base-spinner></base-spinner>
                </div>
            </div>   -->
        </div>   
    </div>

    <div class="recent_posts">       
        <div class="cont">
            <!-- <div class="post_block post_block_full">
                <div class="title">
                    <span> 장터사고팔고</span>
                    <span class="more" @click="moreview('Community','marketplace','isMobile')"> + </span>
                </div>
                <div v-if="marketplaceLists">
                    <div v-if="marketplaceLists.length>0" class="marketplace">
                        <div class="cont_wrapper">
                            <post-content :post="marketplaceLists[0]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                            <div class="list_type">
                                <template v-for="(recent, index) in marketplaceLists" :key="index">
                                    <div class="title_list" v-if="index > 0 && index < 5">
                                        <span class="bullet">-</span>
                                        <post-content :post="recent" titlelength=20 :isDocView="false" :imgview="false"/>
                                    </div>    
                                </template>
                            </div>
                        </div>   
                        <div class="cont_wrapper">
                            <post-content :post="marketplaceLists[5]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                            <div class="list_type">
                                <template v-for="(recent, index) in marketplaceLists" :key="index">
                                    <div class="title_list" v-if="index > 5 ">
                                        <span  class="bullet">-</span>
                                        <post-content :post="recent"  titlelength=20 :isDocView="false" :imgview="false"/>
                                    </div>
                                </template>
                             </div>
                        </div>   
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_marketplace">
                    <base-spinner></base-spinner>
                </div>
            </div>    -->
              <div class="post_block">
                <div class="title">
                    <span> 메타버스</span>
                    <span class="more" @click="moreview('Community','metab','')"> + </span>
                </div>
                <div v-if="marketplaceLists">
                    <div v-if="marketplaceLists.length>0"  class="cont_wrapper">
                        <post-content :post="marketplaceLists[0]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                        <div class="list_type">
                            <template v-for="(recent, index) in marketplaceLists" :key="index">
                                <div class="title_list" v-if="index>0">
                                    <span  class="bullet">-</span>
                                    <post-content :post="recent"  titlelength=20 :isDocView="false" :imgview="false"/>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_humor">
                    <base-spinner></base-spinner>
                </div>
            </div>     
            <div class="post_block">
                <div class="title">
                    <span> 스팀위키</span>
                    <span class="more" @click="moreview('SteamWeaky','','')"> + </span>
                </div>
                <div v-if="fetchSteamWeakyLists">
                    <div v-if="fetchSteamWeakyLists.length>0"  class="cont_wrapper">
                        <post-content :post="fetchSteamWeakyLists[0]" :titleview="false" imgheight="120px" imgwidth="150px"/>
                        <div class="list_type">
                            <template v-for="(recent, index) in fetchSteamWeakyLists" :key="index">
                                <div class="title_list" v-if="index>0">
                                    <span  class="bullet">-</span>
                                    <post-content :post="recent"  titlelength=20 :isDocView="false" :imgview="false"/>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-else class="content_empty">
                        등록된 글이 없습니다.
                    </div>
                </div>
                <div class="loading-spinner" v-if="isLoading_steamweaky">
                    <base-spinner></base-spinner>
                </div>
            </div>            
        </div>
    </div>    
    <!-- <div class="recent_posts">
        <div class="post_block post_block_full">
            <div class="title">
                유머/포토게시판
            </div>
            <div v-if="fetchHumorLists" >
                <div v-if="fetchHumorLists.length>0" class="photo_type">
                    <template v-for="(recent, index) in fetchHumorLists" :key="index">
                        <div class="photo_rect" v-if="index<8">
                            <post-gallery :post="recent" />
                        </div>
                    </template>
                </div>
                <div v-else class="content_empty">
                    등록된 글이 없습니다.
                </div>
            </div>
            <div class="loading-spinner" v-if="isLoading_humor">
                <base-spinner></base-spinner>
            </div>
        </div>
    </div> -->
</template>
<script>
import { postRecent } from '@/components/mixins/pages/postRecent'
export default {
    data(){
        return {          
           
        }
    },
    mixins:[
        postRecent
    ],
    components:{
      
    },
    created(){
        this.recentPost('slide',20);         
    },
    computed:{         

    },
    methods:{
       
    }
}
</script>
<style lang="scss" scoped>
.recent_news{
    height:400px;    
}
.recent_posts
{
    margin-top:10px;
   
    border:1px solid #dee3eb;
    background:#fff;
    .title_wrap{
        padding: 20px 0 0 20px;
        font-family: '맑은고딕';
        border-bottom:1px dotted #ddd;
        padding-bottom:10px;
    }
    .cont{
        display:flex;
    }
    .post_block{
        width:50%;
        padding:20px;
        .title_list_wrap{
            margin-top:5px;
        }
        .title{
            font-weight:bold;
            font-size:16px;
            font-family:'맑은고딕';
            display: flex;
            justify-content: space-between;
            padding-bottom:10px;
            .more{
                cursor: pointer;
                color: #fff;
                margin: 2px;
                background: #ddd;
                border-radius: 3px;
                line-height: 14px;                
                padding: 0 2px;          
            }
            .more:hover{
               transform: translateY(-1px);
                box-shadow: 0 7px 14px rgba(50, 50, 93, 0.2); 
            }
        }
        .cont_wrapper{
            display: flex;
            .list_type{
                padding-left:10px;
               
            }
        }
        .title_list{
            padding-bottom:2px;
            display: flex;
            .bullet{
                display: inline-block;
                width:5px;
                background: url(../../assets/imgs/bullet/bullet_blue.gif) no-repeat -1px 5px;
                text-indent: -999px;

            }
        }
        .photo_type{
            display:flex;
            flex-wrap:wrap;

            .photo_rect{
                width:120px;
                margin-right:10px;
            }
            // .photo_rect{
            //     margin-right:20px;
            // }
            .photo_rect:nth-child(2n){
                margin-right:0;
            }
        }
    }
    .post_block_full{
        width:100%;
        .marketplace{
            display: flex;
            .cont_wrapper:first-child{
                padding-right: 100px;            
            }
        }
    }
    .content_empty{
        padding-top:40px;
        text-align:center;
    }

}
.recent_posts:nth-child(1) {
    margin-top:0;
}
</style>
